import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { IssueStatusEnum } from "@altertec_gparn/lib";
import { Type } from "class-transformer";
import { FileDto } from "../file/file.dto";
import { UserDto } from "../users/user.dto";

export class IssueDto extends BaseEntityDto {
  @Type(() => UserDto)
  user: UserDto;

  userId: string;

  location: string;

  description: string;

  status: IssueStatusEnum;

  fileCount: number;

  @Type(() => FileDto)
  files: FileDto[];
}
